// Vendors
import $ from 'jquery';

// Style
import '../scss/alt-tech.scss';


//The hubspot form is loaded into its containing div after the DOM content has already been loaded
//using mutations to watch the parent hbspt-form div and when the form appears, attach the event listener that'll fire on form submission
document.addEventListener('DOMContentLoaded', function () {

//check for localstorage flag that is set on form submission. If true show the success message, if not hide
if (localStorage.getItem('altTechFormSubmitted') === 'true') {
     // clear the flag
    localStorage.removeItem('altTechFormSubmitted');
    
    // show the success banner
    $('#page--notice.page--notice.alt-tech--notice').css({'display': 'block'});
} 
//Had some beautiful code written to handle submission and such but alas there was an error with error validatino still triggering loading message so hiding for now
    //check if the parent div .hbspt-form element exists
    // const hubspotFormContainer = document.querySelector('.hbspt-form');
    
    // if (hubspotFormContainer) {
    //     // Set up a mutation observer to watch for changes inside the .hbspt-form div
    //     const observer = new MutationObserver(function (mutations) {
    //         mutations.forEach(function (mutation) {
    //             // watch for the form element to be added
    //             const form = hubspotFormContainer.querySelector('form');
    //             if (form) {
    //                 // disconnect the observer once we've located the form
    //                 observer.disconnect();

    //                 //query the form for the submit button and the hidden loading message added below the embed
    //                 const submitButton = form.querySelector('.hs_submit, .hs-submit');
    //                 const loadingMessage = document.getElementById('loading-message');

    //                 if (submitButton) {
    //                     // attach listener on form submit
    //                     form.addEventListener('submit', function () {

    //                         //look for the error field if it exists
    //                         const error = hubspotFormContainer.querySelector('.hs_error_rollup');

    //                         if (!error) {
    //                             // disable the submit button and add a little extra styling
    //                             submitButton.disabled = true;
    //                             submitButton.style.opacity = 0.6;

    //                             // show the loading message
    //                             if (loadingMessage) {
    //                                 loadingMessage.style.display = 'block';
    //                             }
    //                         }
    //                     });
    //                 } else {
    //                     return;
    //                 }
    //             }
    //         });
    //     });
    //     // start observing the .hbspt-form container for child changes
    //     observer.observe(hubspotFormContainer, { childList: true,});
    // } else {
    //     return;
    // }
});

